import { FC } from 'react';
import styles from './styles.module.css';

const ModalFooter: FC = (props) => {

  const {
    children,
  } = props;

  return (
    <div className={styles.footer}>
      {children}
    </div>
  );

};

export default ModalFooter;
